import { render, staticRenderFns } from "./RemoteMedia.vue?vue&type=template&id=32ebdbc0&scoped=true&"
import script from "./RemoteMedia.vue?vue&type=script&lang=js&"
export * from "./RemoteMedia.vue?vue&type=script&lang=js&"
import style0 from "./RemoteMedia.vue?vue&type=style&index=0&id=32ebdbc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebdbc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
